<template>
  <v-card>
    <v-card-title class="pt-6 pb-4">
      <v-icon style="background:#e7e8e9; padding:10px!important; border-radius:50%;" class="mr-4">
        mdi-calendar
      </v-icon>
      <span>Editar Anuncio</span>
      <v-spacer></v-spacer>
      <v-spacer/>
            <v-autocomplete
              :rules="[rules.required]"
              v-model="calendar.influencerIds"
              :items="influencerItems"
              :loading="isLoadingInfluencers"
              :search-input.sync="searchInfluencers"
              hide-no-data
              item-value="id"
              item-text="name"
              label="Influencer(s)"
              placeholder="Escribe para buscar"
              clearable
              multiple
              small-chips
            >
              <template v-slot:item="{ item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.extra">{{ item.extra }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text class="pb-0">
      <v-container>
        <v-row class="ma-0">
          <v-col cols="3">
            <!-- Tipo -->
            <v-autocomplete
              :rules="[rules.required]"
              clearable
              v-model="calendar.activity_type_id"
              :items="activityLists"
              label="Tipo"
              item-text="name"
              item-value="id"
            >
              <template slot="no-data">No existen actividades relacionadas.</template>
            </v-autocomplete>
          </v-col>

          <v-col cols="9">
            <!-- Título -->
            <v-text-field label="Título" v-model="calendar.title"></v-text-field>
          </v-col>
        </v-row>

        <v-row class="ma-0">
          <!-- Fecha -->
          <v-col class="py-0" cols="12" sm="6" md="6">
            <v-menu
              v-model="datePicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :rules="[rules.required]"
                  clearable
                  required
                  v-model="calendar.only_date"
                  label="Fecha"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                color="primary"
                v-model="calendar.only_date"
                @input="datePicker = false"
              />
            </v-menu>
          </v-col>

          <!-- Hora -->
          <v-col class="py-0" cols="12" sm="6" md="6">
            <v-autocomplete
              clearable
              v-model="calendar.only_time"
              prepend-icon="mdi-clock-outline"
              :items="hours"
              label="Hora"
            />
          </v-col>
        </v-row>

        <!-- Editor enriquecido -->
        <vue-editor
          use-custom-image-handler
          @image-added="handleImageAdded"
          v-model="calendar.description"
          :editorOptions="editorSettings"
          :editor-toolbar="customToolbar"
        />
      </v-container>
    </v-card-text>

    <v-card-actions>
      <!-- Imagen destacada -->
      <v-menu top offset-x class="hidden-md-and-down">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            style="font-size:12px;"
            text
            v-bind="attrs"
            v-on="on"
            :color="fileColor(calendar.featured_image)"
          >
            <v-icon class="mr-2">mdi-attachment</v-icon> Imagen Destacada
          </v-btn>
        </template>
        <vue-dropzone
          ref="myVueDropzone"
          id="dropzone-edit"
          :options="dropzoneOptions"
          :useCustomSlot="true"
          @vdropzone-success="uploadSuccess"
          @vdropzone-error="uploadError"
          @vdropzone-removed-file="fileRemoved"
        />
      </v-menu>

      <v-spacer></v-spacer>

      <v-btn color="blue darken-1" text @click="close">
        Cancelar
      </v-btn>
      <v-btn
        color="blue darken-1"
        :disabled="!isValid || gris"
        :loading="gris"
        text
        @click="save"
      >
        Guardar
      </v-btn>
    </v-card-actions>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.message }}
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import { VueEditor, Quill } from "vue2-editor";
import ImageResize from "quill-image-resize-vue";
import { ImageDrop } from "quill-image-drop-module";

Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);

export default {
  components: {
    VueEditor,
    vueDropzone: vue2Dropzone,
  },
  props: {
    calendar: Object, // llega con: id, activity_type_id, only_date, only_time, title, description, user_id, featured_image...
  },
  data: () => ({
    searchInfluencers: '',
    isLoadingInfluencers: false,
    influencers: [],
    snackbar: { show: false, message: null, color: null },
    gris: false,
    timePicker: "",
    datePicker: "",
    fileName: "",
    rules: {
      required: v => !!v || "Campo requerido",
    },
    customToolbar: [
      [{ font: [] }],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline", "strike"],
      [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      ["link", "image", "video", "formula"],
      [{ direction: "rtl" }],
      ["clean"],
    ],
    editorSettings: {
      modules: {
        imageDrop: true,
        imageResize: {},
      },
    },
    dropzoneOptions: {
      url: process.env.VUE_APP_BACKEND_ROUTE + "api/v1/sale/file",
      addRemoveLinks: true,
      maxFiles: 1,
    },
  }),
  watch: {
      searchInfluencers (val) {
      if (this.isLoadingInfluencers) return
      this.isLoadingInfluencers = true
      const base = process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/influencer/search?'
      const url  = base + 'filter[social_networks]=' + encodeURIComponent(val || '')
      this.$nextTick(() => {
          axios.get(url)
          .then(res => {
              this.influencers = (res && res.data && res.data.data) ? res.data.data : []
          })
          .finally(() => { this.isLoadingInfluencers = false })
      })
      }
  },
  computed: {
    influencerItems () {
        const list = this.influencers || []
        return list.map(function (i) {
            return {
            id: i.id,
            name: (i.social_networks && i.social_networks.instagram) ? i.social_networks.instagram : (i.name || ('#' + i.id)),
            extra: i.name && i.last ? (i.name + ' ' + i.last) : (i.name || '')
            }
        })
    },
    isValid() {
      return (
        this.calendar &&
        this.calendar.activity_type_id &&
        this.calendar.only_date &&
        this.calendar.only_time &&
        this.calendar.user_id
      );
    },
    hours() {
      const arr = [];
      for (let i = 0; i < 24; i++) {
        for (let j = 0; j < 4; j++) {
          arr.push(`${this.cero(i)}:${j === 0 ? "00" : 15 * j}:00`);
        }
      }
      return arr;
    },
    activityLists() {
      return this.$store.state.activity.activities;
    },
    usersLists() {
      return this.$store.state.user.users;
    },
    currentUser: {
      get() {
        return this.$store.state.currentUser.user;
      },
    },
  },
  methods: {
    permissions(permission) {
      if (this.currentUser.id == 1) return true;
      if (this.currentUser.permissions != undefined) {
        return this.currentUser.permissions.includes(permission);
      }
      return false;
    },
    cero(i) {
      return i < 10 ? "0" + i : i;
    },
    fileColor(item) {
      if (item) return "success";
      return undefined;
    },
    uploadSuccess(file, response) {
      this.fileName = file;
      this.calendar.featured_image = response.file; // ajusta si tu backend regresa otra clave
    },
    uploadError(file, message) {
      console.log("Upload error", message);
    },
    fileRemoved() {
      this.calendar.featured_image = "";
    },
    close() {
      this.gris = false;
      if (this.fileName) {
        this.$refs.myVueDropzone.removeFile(this.fileName);
        this.fileName = "";
      }
      this.$nextTick(() => {
        this.$emit("closeDialogEditCalendar", false);
      });
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      const formData = new FormData();
      formData.append("image", file);
      axios({
        url: process.env.VUE_APP_BACKEND_ROUTE + "api/v1/sale/file",
        method: "POST",
        data: formData,
      })
        .then((res) => {
          const url = res.data.url;
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch((err) => {
          this.snackbar = { message: err, color: "error", show: true };
        });
    },
    save() {
      this.gris = true;
      // Campos calculados
      this.calendar.last_updated_by_user_id = this.currentUser.id;
      this.calendar.date = `${this.calendar.only_date} ${this.calendar.only_time}`;

      // 🔁 Usa el mismo recurso que el create. Si tu backend usa otra ruta, cámbiala aquí.
      axios
        .put(
          process.env.VUE_APP_BACKEND_ROUTE + "api/v1/activities/" + this.calendar.id,
          Object.assign({}, this.calendar)
        )
        .then(() => this.close())
        .catch((error) => {
          this.snackbar = {
            message: error?.response?.data?.message || "Error al guardar",
            color: "error",
            show: true,
          };
          this.gris = false;
        });
    },
  },
};
</script>

<style lang="css" scoped>
.v-text-field >>> label {
  font-size: 14px !important;
}
</style>
<style>
.v-input__icon--prepend-inner i::before {
  font-size: 18px !important;
  color: #1976D2;
}
.v-text-field input, .v-label {
  font-size: 14px;
}
.v-picker__title.primary {
  display: none;
}
</style>
